import { Box, Flex, Text } from '@chakra-ui/react'
import React, { ReactNode } from 'react'

interface InvoiceEditorSectionProps {
  children: ReactNode
  title: string
  number?: number
  button?: JSX.Element
}

const InvoiceEditorSection = ({
  children,
  title,
  number,
  button
}: InvoiceEditorSectionProps) => {
  return (
    <Box
      alignSelf={'stretch'}
      borderRadius={'4px'}
      pt="30px"
      pb="28px"
      borderBottom={'1px solid'}
      borderColor={'gray.200'}
    >
      <Flex alignItems={'center'} mb="24px">
        {number && (
          <Text
            bgColor="primary.black"
            w="20px"
            h="20px"
            color="white"
            borderRadius="full"
            marginRight="8px"
            lineHeight="20px"
            fontWeight={700}
            fontSize="12px"
            textAlign="center"
          >
            {number}
          </Text>
        )}
        <Text
          fontSize={'16px'}
          fontWeight="700"
          lineHeight={1}
          color={'black.standard'}
        >
          {title}
        </Text>
        {button}
      </Flex>
      <Box>{children}</Box>
    </Box>
  )
}

export default InvoiceEditorSection
